"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeDeclineText = void 0;
var React = require("react");
var HomeDeclineText = /** @class */ (function () {
    function HomeDeclineText() {
        this.occupationDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote because of your occupation.");
        this.jphOccupationDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote because of the joint policyholder\u2019s occupation.");
        this.genericDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote.");
        this.coverLevelDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote because of the level of cover you\u2019ve requested.");
        this.specifiedItemsDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote for the specified items you\u2019ve requested.");
        this.claimsDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to offer you a quote because of your claims history.");
        this.addressDeclineText = React.createElement("p", null, "Sorry, we\u2019re unable to quote for your address.");
        this.underwritingResultCustomerWordings = [
            {
                key: "UWH001",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH002",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH003",
                value: this.getDeclineWording(this.occupationDeclineText)
            },
            {
                key: "UWH004",
                value: this.getDeclineWording(this.jphOccupationDeclineText)
            },
            {
                key: "UWH005",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH006",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH007",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH008",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH009",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH010",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH011",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH012",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH013",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH014",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH015",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH016",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH017",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH018",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH019",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH020",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH021",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH022",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH023",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH024",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH025",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH026",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH027",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH028",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH029",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH030",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH031",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH032",
                value: this.getDeclineWording(this.specifiedItemsDeclineText)
            },
            {
                key: "UWH033",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH034",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH035",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH036",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH037",
                value: this.getDeclineWording(this.specifiedItemsDeclineText)
            },
            {
                key: "UWH038",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH039",
                value: this.getDeclineWording(this.coverLevelDeclineText)
            },
            {
                key: "UWH040",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH041",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH042",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH043",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH044",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH045",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH046",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH047",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH048",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH049",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH050",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH051",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH052",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH053",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH054",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH055",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH056",
                value: this.getDeclineWording(this.addressDeclineText)
            },
            {
                key: "UWH057",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH058",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH059",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH060",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH061",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH062",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH063",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH064",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH065",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH066",
                value: this.getDeclineWording(this.addressDeclineText)
            },
            {
                key: "UWH067",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH068",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH069",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH070",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH071",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH072",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH073",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH074",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH075",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH082",
                value: this.getDeclineWording(this.claimsDeclineText)
            },
            {
                key: "UWH1001",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1002",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1003",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1004",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1005",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1006",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1007",
                value: this.getDeclineWording(this.genericDeclineText)
            },
            {
                key: "UWH1008",
                value: this.getDeclineWording(this.genericDeclineText)
            }
        ];
    }
    HomeDeclineText.prototype.getDeclineWording = function (declineWording) {
        return (React.createElement(React.Fragment, null,
            declineWording,
            React.createElement("p", null,
                "No worries though, our friends at Gallaghers might be able to help. You can contact them about their specialist insurance on:",
                ' ',
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "tel:+44 333 188 7823", "aria-label": "Phone number +44 333 188 7823" }, "0333 188 7823")),
            React.createElement("p", null,
                "Or you can take a look on the",
                ' ',
                React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/find-insurance/", target: "_blank" }, "BIBA website"),
                ' ',
                "to find providers who may offer cover.")));
    };
    return HomeDeclineText;
}());
exports.HomeDeclineText = HomeDeclineText;
//# sourceMappingURL=HomeDeclineText.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/HomeDeclineText.js
// module id = 3658
// module chunks = 0